import React, { useEffect } from 'react'
import { MdCloudDone } from "react-icons/md";

const CustomSuccessModel = ({isOpen , onClose , title = ""}) => {



    useEffect(()=>{
       
        setTimeout(()=>{
            onClose()
        },1500)
    },[isOpen])

    if(!isOpen) return null


  return (
    <div className="fixed z-50 inset-0 flex justify-center items-center bg-black bg-opacity-50">
      <div className="bg-white p-3 w-[297px] h-[190px] rounded-[10px] text-center flex flex-col items-center justify-center">
        <MdCloudDone className="text-6xl text-customGreen mb-3" />
        {title && <div>{title}</div>}
      </div>
    </div>
  )
}

export default CustomSuccessModel
